export default __webpack_public_path__ + "static/media/Close.d487f91d.svg";